import { render, staticRenderFns } from "./DialogContactAgent.vue?vue&type=template&id=2d79c5ee&scoped=true"
import script from "./DialogContactAgent.vue?vue&type=script&lang=js"
export * from "./DialogContactAgent.vue?vue&type=script&lang=js"
import style0 from "./DialogContactAgent.vue?vue&type=style&index=0&id=2d79c5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d79c5ee",
  null
  
)

export default component.exports